import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Link, withRouter} from 'react-router-dom';
import {Breadcrumb, Icon, Label} from 'semantic-ui-react';

import CustomDivider from '../../components/extras/CustomDivider';
import DynamicTable from "../../components/extras/DynamicTable";
import localDB from "../../data/localDB";
import moment from "moment";

class BoxOpening extends Component{
    render(){
        return this.props.is_open ? <Label as={Link} color='orange' to={`/sales/boxes/open/${this.props.id}`}><Icon name='shopping basket' />Caja Abierta</Label>:moment(this.props.end_date).format('M/DD/YYYY - h:mm A');
    }
}

class Boxes extends Component {

    constructor() {
        super();
        this.state = {
            table: {
                headers: ['Nº', 'Fecha Apertura', 'Fecha Cierre', 'Sucursal', 'Usuario', 'Cerrado por', 'Gastos', 'Total', 'Acciones'],
                name: 'Cierre de Caja',
                title: 'Cierres de Caja',
                has_actions: true,
                navigate: true,
                pagination: true,
                url: 'open-boxes',
                values: ['id', 'code', 'start_date', 'end_date', 'branch_office', 'user', 'closed_by', 'expenses', 'total_sales'],
                money_fields: ['total_sales', 'expenses'],
                search_fields: [
                    {id:'branch_office', name:'Sucursal', type:'branch_office', is_main:false},
                    {id:'start_date', name:'Fecha', type:'date', is_main:false},
                    {id:'code', name:'Código', type:'text', is_main:true}
                ],
                child_fields: [{branch_office:'name', user:'full_name', closed_by:'full_name'}],
                datetime_fields: ['start_date',],
                component_fields: [{end_date:BoxOpening}],
                id: 'table_boxes'
            },
        };
    }

    callbackDynamicTable = (response) => {
        if(response.event === 'navigate'){
            localDB.set('box', response.data);
            this.props.history.push(`/sales/boxes/${response.data.id}/${response.data.code}`);
        }
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>Quipuu - Cierres de Caja</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/sales'>Finanzas</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Cierres de Caja</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <DynamicTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable}/>
            </div>
        );
    }
}

export default withRouter(Boxes);



// WEBPACK FOOTER //
// ./src/containers/sales/Boxes.js